import type { SchemaKind } from '@cli-types/core-engine/schema-reader.js'

export function schemaKindFromType(name: string, type: unknown): SchemaKind {
  if (type === undefined) {
    throw new Error(
      `Schema "${name}" is missing required top-level "type". Expected "entity", "single", or "form".`
    )
  }

  if (type === 'form' || type === 'single' || type === 'entity') {
    return type
  }

  throw new Error(
    `Schema "${name}" has unsupported type "${String(type)}". Expected "entity", "single", or "form".`
  )
}
